// Course/CourseCard.tsx

import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FC, FR} from "WideLayout/Layouts";
import {useTheme} from "Theme/ThemeContext";
import {ICourse} from "../../Types/psychology/course";

interface CourseCardProps {
    course: ICourse;
}

const CourseCard: React.FC<CourseCardProps> = ({course}) => {
    const {plt} = useTheme();
    const location = useLocation();
    const linkTo = location.pathname.includes('cabinet')
        ? `/cabinet/course/${course.id}`
        : `/course/${course.id}`;
    // Функция для обрезки текста до указанного лимита символов
    const truncate = (text: string, maxLength: number) => {
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + '...';
    };
    return (
        <FC pb={2} rounded={4} maxW={300} minW={300}
            cursorPointer
            cls={'hover-scale-4'}
            bg={`${plt.colors.secondary.light}33`}
            color={plt.text.primary80}>
            <Link to={linkTo} style={{color: plt.text.primary80}}
                  className="text-decoration-none flex-grow-1">
                <FC h={'100%'}>
                    <FC g={1}>
                        {course.picture &&
                            <img src={course.picture} alt={course.name}
                                 className="card-img-top maxh-150px w-100 object-fit-cover rounded-4"/>
                        }
                    </FC>
                    <FC px={2} grow pt={1}>
                        <h5 style={{
                            fontSize: '1.1rem',
                            fontWeight: 500,
                            color: plt.text.primary75
                        }}>{course.name}</h5>
                        {course.description && <p style={{whiteSpace: 'pre-wrap'}}>
                            {truncate(course.description, 50)}
                        </p>}
                        {!course.accessed && course.is_public &&
                            <FR rounded={3} my={1} cls={'text-nowrap'}
                                w={'min-content'} px={1} fontWeight={500}
                                bg={`${plt.colors.secondary.light}aa`}
                                color={plt.text.primary60}>
                                Бесплатно сейчас!</FR>
                        }
                        {course.accessed &&
                            <FR rounded={3} my={1} cls={'text-nowrap'}
                                w={'min-content'} px={1} fontWeight={500}
                                bg={`${plt.colors.secondary.main}aa`}
                                color={'#fff'}>
                                Доступен вам</FR>
                        }
                        <span className={'mt-auto'}>{course.lessons.length} уроков внутри</span>
                    </FC>
                </FC>
            </Link>
        </FC>
    );
};

export default CourseCard;
